import { render } from "./AddGroupForm.vue?vue&type=template&id=57006c68&scoped=true"
import script from "./AddGroupForm.vue?vue&type=script&lang=js"
export * from "./AddGroupForm.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./AddGroupForm.vue?vue&type=style&index=1&id=57006c68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57006c68"]])

export default __exports__